(function ($) {
	'use strict';

	function scrollToTarget(target) {
		var $target = $(target);

		if (!$target.length) {
			return;
		}

		$('html, body').animate({
			scrollTop: Math.max(0, $target.offset().top - 96)
		}, 650);
	}

	function setFieldError(name, message) {
		var $field = $('[name="' + name + '"]').closest('.contacts-field');
		var $error = $('[data-error-for="' + name + '"]');

		if (message && !$error.length && $field.length) {
			$error = $('<small></small>').attr('data-error-for', name).appendTo($field.first());
		}

		$field.toggleClass('has-error', !!message);
		$error.text(message || '');

		return $field.length > 0;
	}

	function clearErrors() {
		$('.contacts-field').removeClass('has-error');
		$('[data-error-for]').text('');
		$('.contacts-alert--error').remove();
	}

	function validateForm($form) {
		var valid = true;
		var email = $.trim($form.find('[name="email"]').val());
		var file = $form.find('[name="file"]')[0].files[0];
		var requiredFields = {
			name: window.___('Заповніть це поле'),
			email: window.___('Заповніть це поле'),
			subject: window.___('Оберіть тему звернення'),
			message: window.___('Заповніть це поле')
		};

		clearErrors();

		$.each(requiredFields, function (name, message) {
			if (!$.trim($form.find('[name="' + name + '"]').val())) {
				setFieldError(name, message);
				valid = false;
			}
		});

		var emailPattern = /^[A-Za-z0-9.!#$%&'*+\/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/;
		if (email && !emailPattern.test(email)) {
			setFieldError('email', window.___('Введіть коректний email латиницею'));
			valid = false;
		}

		if (!$form.find('[name="user_type"]:checked').length) {
			setFieldError('user_type', window.___('Оберіть тип звернення'));
			valid = false;
		}

		if (!$form.find('[name="agreement"]').is(':checked')) {
			setFieldError('agreement', window.___('Потрібно підтвердити згоду перед відправкою'));
			valid = false;
		}

		if (file) {
			var allowed = ['image/png', 'image/jpeg', 'application/pdf'];
			var extensionAllowed = /\.(png|jpe?g|pdf)$/i.test(file.name);

			if ($.inArray(file.type, allowed) === -1 && !extensionAllowed) {
				setFieldError('file', window.___('Файл має бути у форматі PNG, JPG або PDF'));
				valid = false;
			}

			if (file.size > 5 * 1024 * 1024) {
				setFieldError('file', window.___('Розмір файлу не має перевищувати 5 МБ'));
				valid = false;
			}
		}

		if (!valid) {
			var $first = $('.contacts-field.has-error').first();
			if ($first.length) {
				$('html, body').animate({
					scrollTop: Math.max(0, $first.offset().top - 120)
				}, 600, function () {
					$first.find('input, textarea, button').filter(':visible').first().trigger('focus');
				});
			}
		}

		return valid;
	}

	function showSuccess($form) {
		var successHtml = [
			'<div class="contacts-success" data-contact-success>',
			'<i class="uil uil-check-circle"></i>',
			'<div>',
			'<strong>' + window.___('Дякуємо! Ваше повідомлення надіслано') + '</strong>',
			'<p>' + window.___('Ми отримали звернення і відповімо вам на email у робочий час.') + '</p>',
			'<button type="button" class="contacts-link-button" data-contact-reset>' + window.___('Надіслати ще одне повідомлення') + '</button>',
			'</div>',
			'</div>'
		].join('');

		$form.find('[data-contact-success]').remove();
		$form.find('.contacts-form-card__head').after(successHtml);
		$form[0].reset();
		$form.find('[name="subject"]').val('');
		$form.find('[data-dropdown-label]').text(window.___('Оберіть тему звернення'));
		$form.find('[data-file-label]').text(window.___('Можна додати скріншот або документ'));
		scrollToTarget($form);
	}

	function showFormError($form, message) {
		var errorHtml = [
			'<div class="contacts-alert contacts-alert--error">',
			'<strong>' + window.___('Не вдалося надіслати повідомлення') + '</strong>',
			'<p>' + (message || window.___('Спробуйте ще раз або напишіть нам на support@careerdesk.eu.')) + '</p>',
			'<button type="button" class="contacts-link-button" data-contact-retry>' + window.___('Спробувати ще раз') + '</button>',
			'</div>'
		].join('');

		$form.find('.contacts-alert--error').remove();
		$form.find('.contacts-form-card__head').after(errorHtml);
		scrollToTarget($form);
	}

	function runRecaptcha($form) {
		var siteKey = $form.data('recaptcha-site-key');
		var deferred = $.Deferred();

		if (!siteKey) {
			deferred.resolve();
			return deferred.promise();
		}

		if (!window.grecaptcha) {
			deferred.reject(window.___('Не вдалося завантажити перевірку reCAPTCHA. Оновіть сторінку та спробуйте ще раз.'));
			return deferred.promise();
		}

		window.grecaptcha.ready(function () {
			window.grecaptcha.execute(siteKey, {action: 'contact'}).then(function (token) {
				$form.find('[name="recaptcha_token"]').val(token);
				deferred.resolve();
			}, function () {
				deferred.reject(window.___('Не вдалося пройти перевірку reCAPTCHA. Оновіть сторінку та спробуйте ще раз.'));
			});
		});

		return deferred.promise();
	}

	function submitContactForm($form, $submit, $submitText) {
		$.ajax({
			url: $form.attr('action'),
			method: 'POST',
			data: new FormData($form[0]),
			processData: false,
			contentType: false,
			headers: {
				'Accept': 'application/json'
			}
		}).done(function () {
			clearErrors();
			showSuccess($form);
		}).fail(function (xhr) {
			var response = xhr.responseJSON || {};
			var hasVisibleFieldError = false;
			var firstHiddenError = '';

			clearErrors();
			if (response.errors) {
				$.each(response.errors, function (name, messages) {
					var hasField = setFieldError(name, messages[0]);
					hasVisibleFieldError = hasField || hasVisibleFieldError;
					if (!hasField && !firstHiddenError) {
						firstHiddenError = messages[0];
					}
				});
				var $first = $('.contacts-field.has-error').first();
				if ($first.length) {
					$('html, body').animate({ scrollTop: Math.max(0, $first.offset().top - 120) }, 600);
				} else if (!hasVisibleFieldError) {
					showFormError($form, firstHiddenError || response.message || window.___('Перевірте поля форми'));
				}
			} else {
				showFormError($form, response.message);
			}
		}).always(function () {
			$submit.prop('disabled', false).removeClass('is-loading');
			$submitText.text($submit.data('submit-text'));
		});
	}

	function setPreset(type, subject) {
		var $form = $('#contact-form');

		if (type) {
			$form.find('[name="user_type"][value="' + type + '"]').prop('checked', true).trigger('change');
		}

		if (subject) {
			var $option = $('[data-contact-dropdown] [data-value="' + subject + '"]');
			$form.find('[name="subject"]').val(subject);
			$form.find('[data-dropdown-label]').text($option.text() || window.___('Оберіть тему звернення'));
		}
	}

	$(function () {
		var oldSubject = $('#contact-subject-input').val();
		if (oldSubject) {
			var $oldOption = $('[data-contact-dropdown] [data-value="' + oldSubject + '"]');
			$('[data-dropdown-label]').text($oldOption.text());
		}

		$(document).on('click', '[data-contact-scroll]', function (event) {
			var target = $(this).attr('href');
			if (target && target.charAt(0) === '#') {
				event.preventDefault();
				setPreset($(this).data('contact-type'), $(this).data('contact-subject'));
				scrollToTarget(target);
			}
		});

		$(document).on('click', '.contacts-dropdown__toggle', function () {
			var $dropdown = $(this).closest('[data-contact-dropdown]');
			var isOpen = $dropdown.hasClass('is-open');
			$('[data-contact-dropdown]').removeClass('is-open').find('.contacts-dropdown__toggle').attr('aria-expanded', 'false');
			$dropdown.toggleClass('is-open', !isOpen);
			$(this).attr('aria-expanded', !isOpen ? 'true' : 'false');
		});

		$(document).on('click', '.contacts-dropdown__menu button', function () {
			var $button = $(this);
			var $dropdown = $button.closest('[data-contact-dropdown]');

			$dropdown.removeClass('is-open').find('.contacts-dropdown__toggle').attr('aria-expanded', 'false');
			$dropdown.find('[data-dropdown-label]').text($button.text());
			$('#contact-subject-input').val($button.data('value')).trigger('change');
			setFieldError('subject', '');
		});

		$(document).on('click', function (event) {
			if (!$(event.target).closest('[data-contact-dropdown]').length) {
				$('[data-contact-dropdown]').removeClass('is-open').find('.contacts-dropdown__toggle').attr('aria-expanded', 'false');
			}
		});

		$('[data-contact-faq]').on('click', '.contacts-faq__item > button', function () {
			var $item = $(this).closest('.contacts-faq__item');
			var isOpen = $item.hasClass('is-open');

			$item.toggleClass('is-open', !isOpen);
			$(this).attr('aria-expanded', !isOpen ? 'true' : 'false');
			$item.find('.contacts-faq__content').stop(true, true).slideToggle(220);
		});

		$('.contacts-faq__item:not(.is-open) .contacts-faq__content').hide();

		$('#contact-file').on('change', function () {
			var file = this.files[0];
			$('[data-file-label]').text(file ? file.name : window.___('Можна додати скріншот або документ'));
			setFieldError('file', '');
		});

		$('#contact-form').on('input change', 'input, textarea', function () {
			var name = $(this).attr('name');
			if (name) {
				setFieldError(name, '');
			}
		});

		$(document).on('click', '[data-contact-reset], [data-contact-retry]', function () {
			$(this).closest('.contacts-success, .contacts-alert').remove();
			scrollToTarget('#contact-form');
		});

		$('#contact-form').on('submit', function (event) {
			event.preventDefault();

			var $form = $(this);
			var $submit = $form.find('[type="submit"]');
			var $submitText = $submit.find('span');

			if (!validateForm($form) || $submit.prop('disabled')) {
				return;
			}

			$submit.prop('disabled', true).addClass('is-loading');
			$submitText.text($submit.data('loading-text'));

			runRecaptcha($form).done(function () {
				submitContactForm($form, $submit, $submitText);
			}).fail(function (message) {
				showFormError($form, message);
				$submit.prop('disabled', false).removeClass('is-loading');
				$submitText.text($submit.data('submit-text'));
			});
		});
	});
})(jQuery);
